import { CurrencyForm } from '../../features/CurrencyForm';

const CreateCurrencyPage = () => {
  return (
    <>
      <CurrencyForm />
    </>
  );
};

export default CreateCurrencyPage;
